import React from 'react'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'

export function FullScreenLoader() {
  return (
    <div className="flex h-full min-h-screen items-center justify-center bg-background">
      <GenieLogo className="h-10 w-10 animate-pulse text-muted-foreground" />
    </div>
  )
}
